export interface IErrorPayload {
  message: string,
  stack: string,
  file?: string,
}

export default defineNuxtPlugin((nuxtApp) => {
  
  const send = (payload: IErrorPayload, type: string) => {
    $fetch('/api/v1/app/events/error', {
      method: 'POST',
      body: {
        source: type,
        message: payload.message || String(payload),
        stack: payload.stack,
        file: payload.file || 'unknown',
      },
    }).catch(() => {})
  }

  if(process.env.NUXT_PUBLIC_APP_ENV === 'production' || process.env.NUXT_PUBLIC_APP_ENV === 'staging') {
    // typical errors from vue
    nuxtApp.vueApp.config.errorHandler = (err: unknown, instance: ComponentPublicInstance | null) => {
      const componentName = instance?.$options?.__name || instance?.$options?.name || 'UnknownComponent'
      const errorPayload = {
        message: err instanceof Error ? err.message : String(err),
        stack: err instanceof Error ? err.stack || '' : '',
        file: `file: ${componentName} url: ${window.location.href}`,
      }
      send(errorPayload, 'CLIENT_VUE')
    }
  
    // other nuxt errors
    nuxtApp.hook('app:error', (err) => {
      send(err, 'NUXT')
    })
    
    // promises
    window.addEventListener('unhandledrejection', (ev) => send(ev.reason, 'CLIENT_PROMISE'))
  
    // all errors from front
    window.onerror = (message, source, lineno, colno, error) => send({
      message: message.toString() || `${error}`,
      stack: `line: ${lineno} \n column: ${colno} \n source: ${source}`,
      file: source,
    }, 'CLIENT')
  }
})
